import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="search"
export default class extends Controller {
  static targets = ["input", "results"];

  connect() {
    this.timeout = null;
    this.boundHandleClickOutside = this.handleClickOutside.bind(this);
    document.addEventListener("click", this.boundHandleClickOutside);
    // Clear search results on Turbo navigation
    document.addEventListener("turbo:before-visit", this.clearResults.bind(this));
    document.addEventListener("turbo:before-cache", this.clearResults.bind(this));
  }

  disconnect() {
    document.removeEventListener("click", this.boundHandleClickOutside);
    document.removeEventListener("turbo:before-visit", this.clearResults.bind(this));
    document.removeEventListener("turbo:before-cache", this.clearResults.bind(this));
  }

  search() {
    clearTimeout(this.timeout);

    this.timeout = setTimeout(() => {
      if (this.inputTarget.value.length >= 2) {
        const form = this.inputTarget.closest("form");
        form.requestSubmit ? form.requestSubmit() : form.submit();
      } else {
        this.clearResults();
      }
    }, 300);
  }

  clearResults() {
    if (this.hasResultsTarget) {
      this.resultsTarget.innerHTML = "";
    }
    // Also clear mobile results
    const mobileResults = document.getElementById("search_results_mobile");
    if (mobileResults) {
      mobileResults.innerHTML = "";
    }
  }

  handleClickOutside(event) {
    // Check if click is outside both the search input and the results
    const isClickInsideSearch = this.element.contains(event.target);

    // Also check for mobile results which might be outside the controller element
    const mobileResults = document.getElementById("search_results_mobile");
    const isClickInsideMobileResults =
      mobileResults && mobileResults.contains(event.target);

    // Check desktop results target
    const isClickInsideDesktopResults =
      this.hasResultsTarget && this.resultsTarget.contains(event.target);

    const isClickInsideResults =
      isClickInsideDesktopResults || isClickInsideMobileResults;

    // Only clear if there are actually results to clear
    const hasResults =
      (this.hasResultsTarget && this.resultsTarget.innerHTML.trim() !== "") ||
      (mobileResults && mobileResults.innerHTML.trim() !== "");

    if (!isClickInsideSearch && !isClickInsideResults && hasResults) {
      this.clearResults();
    }
  }
}
